import { httpClient } from '@/network/clientController'

/** Get info about the customer account manager (or agency if there's no manager)
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customersmanager
*/
export const getCustomerManagerInfo = (payload) => {
	return httpClient({
		method: 'GET',
		url: 'customers/manager',
		isCancellable: true
	})
}
